<mbs-modal>
  <ng-container modal-body>
    <mbs-alert
      [type]="mbsPopupType.info"
      class="mb-4"
      icon="ico ico-info-circle">
      {{ 'shared:computers.connect.youWillBePrompted' | i18next }}
    </mbs-alert>
    <form class="form-group mb-0">
      <mbs-radio
        [label]="'shared:computers.connect:openSSHConnection' | i18next"
        class="mb-3"
        [size]="size.lg"
        [formControl]="form"
        [value]="connectionType.SSH"></mbs-radio>
      <mbs-radio
        [label]="'shared:computers.connect:openVNCConnection' | i18next"
        class="mb-0"
        [size]="size.lg"
        [formControl]="form"
        [value]="connectionType.VNC"></mbs-radio>
    </form>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      (click)="baseModal.save(form.value)">
      {{ 'shared:products.ra' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      (click)="baseModal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
